import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Table from "../../components/table/Table";

const CustomerView = ({ Close, customer }) => {
  const [tab, setTab] = useState(1);
  const [pendingInvoices, setPendingInvoices] = useState([]);
  const [completedInvoice, setcompletedInvoice] = useState([]);

  const salesState = useSelector(state=> state.salesReducer)
  const {salesListByCustomerId} = salesState

  const renderHead = (item, index) => <th key={index}>{item}</th>;

  const renderBody = (item, index) => (
    <tr key={index}>
      {/* <td>{item.id}</td> */}
      <td>{item.invoiceNumber}</td>
      <td>
      {item.invoiceType === "Sales" ? (
        <span>
        {item.invoiceCustomer &&
          item.invoiceCustomer.length !== 0 &&
          (item.invoiceCustomer[0].firstName)}
            </span>
      ) : (
        <span>
        {item.invoiceBroker &&
          item.invoiceBroker.length !== 0 &&
          item.invoiceBroker[0].firstName}
          </span>
      )
        }
      </td>
      <td>{moment(item.invoiceDate).format("DD-MM-YYYY")}</td>
      <td>
        {" "}
        <div
          className={`rounded p-2 bg-${
            item.invoiceType === "Sales" ? "green" : "red"
          }-600`}
        >
          {item.invoiceType}{" "}
        </div>{" "}
      </td>
      <td>{item.invoicePaymentType}</td>

      <td>
        {Number(item.invoiceSubTotal).toLocaleString()} {item.invoiceCurrency}
      </td>
      <td>
        {Number(item.invoiceDiscountAmount).toLocaleString()}{" "}
        {item.invoiceCurrency}
      </td>
      <td>
        {Number(item.invoiceGrandTotal).toLocaleString()} {item.invoiceCurrency}
      </td>
      <td>
        {Number(item.invoiceBalanceToReceived).toLocaleString()}{" "}
        {item.invoiceCurrency}
      </td>
      <td>
        {Number(item.invoiceBalanceToCustomer).toLocaleString()}{" "}
        {item.invoiceCurrency}
      </td>

      <td className="">
        {item.invoiceStatus}
        {item.invoiceStatus !== "Complete" &&
          item.invoiceStatus !== "Return" &&
          item.invoiceStatus !== "Cancel" && (
            <div className="flex w-full">
              <i
                // onClick={() => changeToComplete(item)}
                className="w-full bg-green-500 m-2 p-2 text-xs font-extrabold text-white rounded"
              >
                C
              </i>
              <i
                // onClick={() => changeToPending(item)}
                className="w-full bg-red-500 m-2 p-2 text-xs font-extrabold text-white rounded"
              >
                P
              </i>
            </div>
          )}
      </td>
      <td className="flex justify-end items-center">
        <div
        //   onClick={() => onClickEditedInvoice(item)}
          className="bg-red-500 rounded p-2 bx bx-edit mx-2"
        ></div>
        <div
        //   onClick={() => {
        //     onViewInvoice(item);
        //   }}
          className="bg-green-500 rounded p-2 bx bx-show mx-2"
        ></div>
      </td>
    </tr>
  );

  const invoiceTableHead = [
    "invoice-no",
    "customer",
    "date",
    "type", //sales //on-approval
    "payment type", //cash //credit
    "sub total",
    "discount",
    "grand total",
    "balance to received",
    "balance to customer",
    "status",
    "Action",
  ];
  useEffect(() => {
    setPendingInvoices((salesListByCustomerId || []).filter(x=>x.invoiceStatus === "PaymentPending"))
    setcompletedInvoice((salesListByCustomerId || []).filter(x=>x.invoiceStatus === "Complete"))
    console.log("Selected customer invoices", salesListByCustomerId)
  }, [salesListByCustomerId])

  const invoiceList = (status, type , source)  => {
    // let invoices = sales;
    // if (status && invoices && invoices.length !== 0) {
    //   invoices = invoices.filter((x) => x.invoiceStatus === status);
    // }
    // if (type && invoices && invoices.length !== 0) {
    //   invoices = invoices.filter((x) => x.invoiceType === type);
    // }

    return (
      <div className="w-full overflow-x-scroll p-4">
        <Table
        showSearch
        showLimit
          limit="10"
          headData={invoiceTableHead}
          renderHead={(item, index) => renderHead(item, index)}
          bodyData={source}
          renderBody={(item, index) => renderBody(item, index)}
        />
      </div>
    );
  };

  return (
    <div className="flex text-white flex-col w-full">
      <div style={{ height: 200 }} id="coverPic" className="flex bg-gray-900 ">
        <div className="flex items-center justify-center p-5">
          <img
            style={{ width: "190px", height: "184px", objectFit: "cover" }}
            className="rounded-full border-2  border-white"
            src="https://i.insider.com/5ca389adc6cc503c5a53fd96?width=600&format=jpeg"
            alt="customerProfilePic"
          ></img>
        </div>
        <div className="flex justify-center items-start flex-col flex-1">
            <div className="font-extrabold text-white text-4xl">{customer.firstName} {customer.lastName}</div>
            <div className="font-extrabold text-white text-sm">Email : {customer.email} <br></br>Mobile : {customer.mobile}<br></br>Address : {customer.homeAddress}</div>
            <div className="font-extrabold italic text-white text-sm">Company : {customer.businessName}</div>
        </div>
        <div className="flex justify-center items-end flex-col flex-1 p-2">
            <div className="font-extrabold text-white text-xl">Pending Payments : {pendingInvoices.reduce((accumulator, current)=> accumulator + Number(current.invoiceBalanceToReceived), 0).toLocaleString() }</div>
            {/* <div className="font-extrabold text-white text-sm">Email : {customer.email} <br></br>Mobile : {customer.mobile}<br></br>Address : {customer.homeAddress}</div>
            <div className="font-extrabold italic text-white text-sm">Company : {customer.businessName}</div> */}
        </div>
      </div>
      <div
        style={{ height: 50 }}
        id="tab"
        className="flex justify-evenly bg-slate-600"
      >
        <div
          onClick={() => setTab(1)}
          id="tab-1"
          className="flex p-3 font-extrabold cursor-pointer hover:bg-slate-700 w-full items-center"
        >
          Profile
        </div>
        <div
          onClick={() => setTab(2)}
          id="tab-2"
          className="flex p-3 font-extrabold cursor-pointer hover:bg-slate-700 w-full items-center"
        >
          Pending Invoice ({pendingInvoices.length})
        </div>
        <div
          onClick={() => setTab(3)}
          id="tab-3"
          className="flex p-3 font-extrabold cursor-pointer hover:bg-slate-700 w-full items-center"
        >
          Completed Invoice ({completedInvoice.length})
        </div>
      </div>
      <div id="tabBody">
        {tab === 1 && (
          <div id="tab-1">
            {/* firstName: {customer.firstName}
            customerId: {customer.customerId},
            lastName: {customer.lastName},
            homeAddress: {customer.homeAddress}, country: {customer.country},
            city: {customer.city}, mobile: {customer.mobile}, email:{" "}
            {customer.email}, status:{customer.status}, businessName:{" "}
            {customer.businessName}, businessAddress: {customer.businessAddress}
            , businessEmail: {customer.businessEmail}, businessEmail2:{" "}
            {customer.businessEmail2}, businessContact:{" "}
            {customer.businessContact}, businessContact2:{" "}
            {customer.businessContact2}, */}
          </div>
        )}
        {tab === 2 && <div id="tab-2">{invoiceList("","",pendingInvoices)}</div>}
        {tab === 3 && <div id="tab-3">{invoiceList("","",completedInvoice)}</div>}
      </div>
    </div>
  );
};

export default CustomerView;
